import React from "react";
import { Button } from "@design-system/Button/Button";
import { LeftArrowIcon } from "@icons";
import styles from "./MatchingViewHeader.module.scss";

interface Props {
    onBack(): void;
}

export const MatchingViewHeader: React.FC<Props> = ({ onBack }) => (
    <div className={styles.header}>
        <Button
            size="sm"
            variant="primary"
            iconOnly
            onClick={onBack}
            aria-label="Go back"
            data-testid="financial-document-matching-view-back-button"
        >
            <LeftArrowIcon />
        </Button>
        Find transaction
    </div>
);
